import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { router } from './plugins/vue-router'
import './plugins/vuex'
import './plugins/vant'
import './plugins/js-md5'
import './utils/axios'
import './utils/lodash'
// import './utils/wx-jssdk'
import { Decrypt } from '@/utils/crypto'
import { checkPlatform, callLogin } from '@/utils/platform'
// import './utils/v-console'
import { ImagePreview } from 'vant'
import '@/assets/css/common.styl'
Vue.config.productionTip = false

import uploader from 'vue-simple-uploader'
Vue.use(uploader)

import VueSignature from 'vue-signature-pad'
// 自定义表单验证方法库
import validateForm from '@/utils/validate-form.js'

Vue.prototype.validateForm = validateForm
Vue.prototype.$Decrypt = Decrypt
Vue.prototype.$checkPlatform = checkPlatform
Vue.prototype.$callLogin = callLogin
Vue.use(ImagePreview)
Vue.use(VueSignature)

Vue.prototype.wx = window.wx
// 路由控制
router.afterEach(() => {
  document.title = '\u200E'
})

new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
